import React, { Component } from 'react';
import $ from "jquery";
import {  Link } from 'react-router-dom';

class Accomplishments extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card borderNone">
                          <div className="card-body">
                            <h5 className="card-title">Leistungen</h5>
                            <h6 className="card-subtitle mb-2 text-muted"></h6>
                            <p className="card-text">
								Der T&auml;tigkeitsschwerpunkt der Kanzlei liegt in der steuerlichen und betriebswirtschaftlichen Beratung von Freiberuflern wie Architekten und Ingenieuren, &Auml;rzten, Hotelbetrieben, Werbeagenturen sowie kleinen und mittelst&auml;ndischen Unternehmen des Handels und der Produktion. 
								<br />
								Hierbei  nimmt das T&auml;tigkeitsfeld der Jahresabschlusserstellung und die Erstellung der Steuererkl&auml;rungen naturgem&auml;&szlig; das gr&ouml;&szlig;te T&auml;tigkeitsfeld ein, denn gerade anhand der Jahresabschl&uuml;sse k&ouml;nnen f&uuml;r die Zukunft Schwerpunkte der zu beachtenden Kriterien betriebswirtschaftlicher Lenkungsinstrumente herausgearbeitet werden. Bei allem steht f&uuml;r uns das Wohl und der finanzielle Erfolg des Mandanten immer im Vordergrund. 
								<br />
								F&uuml;r unsere Mandanten &uuml;bernehmen wir auch auf Wunsch die Abwicklung aller T&auml;tigkeiten auf dem Gebiet der Lohn- und Gehaltsbuchhaltung und der Finanzbuchhaltung einschlie&szlig;lich der F&uuml;hrung der B&uuml;cher inklusive der Lohnabrechnungen f&uuml;r die Mitarbeiter, die An- und Abmeldungen bei Sozialversicherungstr&auml;gern und Krankenkassen sowie der Erstellung der obligatorischen Meldungen bei Finanz&auml;mtern, Krankenkassen und Sozialversicherungstr&auml;gern.
								<br />
								Ein wesentliches Moment unseres Beratungskonzeptes ist dem Kriterium der Verschwiegenheit und der Unabh&auml;ngigkeit gewidmet. Diese sind eigentlich selbstverst&auml;ndlich f&uuml;r die Berufsaus&uuml;bung des Steuerberaters und vereidigten Buchpr&uuml;fers. Wir pflegen daher keine Zusammenarbeit mit Finanz- und Anlageberatern oder Grundst&uuml;cksmaklern und geben somit auch keine Anlageempfehlungen gegen&uuml;ber unseren Mandanten ab.
								<br />
								Ebenso empfehlen wir auch sonst keine steuerlichen Konstruktionen im Anlagenbereich, die mit der Erzielung von nicht marktwirtschaftlich konformen Ergebnissen in Zusammenhang stehen.  Wir sind ausschlie&szlig;lich steuerlich und betriebswirtschaftlich beratend t&auml;tig und begleiten unsere Mandanten und Unternehmen von der Gr&uuml;ndungsberatung bis zur Aufgabe oder Beendigung des Betriebes. Das finanzielle Wohlergehen unserer Mandanten ist dabei f&uuml;r uns immer das Ziel jeglicher Beratungst&auml;tigkeit.
                            </p>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Accomplishments;


// WEBPACK FOOTER //
// ./src/Accomplishments.js